    import { Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
// import {
//     AllCommunityModule, // or AllEnterpriseModule
// } from 'ag-grid-community';
import { ModuleRegistry,AllEnterpriseModule } from 'ag-grid-enterprise';
    import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
    import Keycloak from 'keycloak-js';

// Register the module
ModuleRegistry.registerModules([
    AllEnterpriseModule, // or AllEnterpriseModule
]);


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})

export class AppComponent implements OnInit{


    /**
     * Constructor
     */
    constructor(private primeng: PrimeNG) {}

    ngOnInit(): void {
       this.primeng.ripple.set(true);

    }



}
